import EasybillIcon from '@/icons/easybill.svg';
import { normalizeDateFE } from '@/core/normalization';
import IntegrationsConnectButton from './IntegrationsConnectButton';
import InvalidIntegrationIcon from '@/icons/integration-invalid.svg?react';
import ConnectIcon from '@/icons/connect.svg?react';
import { EasybillData } from '@/core/types';
import { formatDate } from '@/core/helpers';
import { useTranslation } from 'react-i18next';

interface Props {
  easybillData?: EasybillData;
  onClickConnect: () => void;
}

export const EasybillIntegrationWidget = ({
  easybillData,
  onClickConnect,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className='flex items-center justify-between font-bold'
        data-testid='integrations-easybill'
      >
        <div className='flex flex-grow items-center'>
          <img
            src={EasybillIcon}
            alt='easybill'
            style={{
              width: 40,
              height: 40,
            }}
            className='mr-2 flex-shrink-0'
          />
          <span>easybill</span>
        </div>
        {(!easybillData || !easybillData.is_valid) && (
          <IntegrationsConnectButton
            testId='easybill-btn'
            onClick={onClickConnect}
          />
        )}
        {
          <div>
            {easybillData?.is_valid ? (
              <ConnectIcon
                className='Integrations__validIcon'
                data-testid='easybill-valid'
              />
            ) : easybillData?.invalid_date ? (
              <InvalidIntegrationIcon data-testid='easybill-invalid' />
            ) : null}
          </div>
        }
      </div>
      <div data-testid='easybill-connected'>
        <div className='flex items-center justify-between'>
          {easybillData?.is_valid ? (
            <div className='mt-2 flex justify-between gap-x-1'>
              <div>{t('Connected')}</div>
              {easybillData.create_date && (
                <div data-testid='easybill-connected-date'>
                  {formatDate(
                    normalizeDateFE(easybillData.create_date),
                    'dd.MM.yyyy'
                  )}
                </div>
              )}
            </div>
          ) : easybillData?.invalid_date ? (
            <div>API key{t('*n* non-valid').replace('*n*', '')}</div>
          ) : null}
        </div>
        {!easybillData?.is_valid && easybillData?.invalid_date && (
          <div
            className='Text--red mb-4 text-sm'
            data-testid='easybill-invalid-date'
          >
            <span>{t('since')}</span>{' '}
            <span>
              {formatDate(
                normalizeDateFE(easybillData.invalid_date),
                'dd.MM.yyyy'
              )}
            </span>
          </div>
        )}
      </div>
    </>
  );
};
